import styled from 'styled-components';
import { respondTo } from 'components/styles/_respondTo';
import { colors } from 'components/styles/_variables';

export const Wrapper = styled.div`
  padding: 0 20px;
  width: 100%;
  flex: 1;
  display: flex;
  box-shadow: inset 0 -1px 0 0 ${colors.elements.border};
  ${respondTo.mobile`
    flex-direction: column;
    box-shadow: unset;
  `}
  ${respondTo.smallDesktop`
     flex-wrap: wrap;
  `}
`;
